module.exports = __webpack_public_path__ + "img/frame (233).9328b0a9.jpg";